<div class="flex flex-col h-full">
  <div class="flex py-2 justify-between">
    <div class="flex w-1/5">
      <elcia-search [control]="searchControl"/>
    </div>
    <div class="flex gap-2">
      <elcia-button (onClick)="showForm()" [label]="'action.add-plugin' | translate" [icon]="'plus'"/>
    </div>
  </div>

  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-plugin-grid
        (onDelete)="onPluginDelete($event)"
        (pluginSelected)="onPluginSelect($event)"
        [plugins]="plugins()"/>
    }
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    (onDelete)="deletePlugin()"
    [isActionLoading]="isFormSaving()"
    [mustDisplayDeleteButton]="isEditMode()"
    [size]="'medium'"
    [title]="'entity.plugin' | translate">

    @if (isLoadingSelected()) {
      <elcia-loader/>
    } @else {
      <elcia-plugin-form
        (onSubmit)="submit($event)"
        [initialValue]="store.selectedPlugin() ?? undefined"
      />
    }
  </elcia-dialog>
}
